export const appPageTransition = {"name":"page","mode":"out-in"}

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"hid":"description","name":"description","content":"A series of authentic apartment hotels that brings together connection, warmth and flexibility."}],"link":[{"rel":"preconnect","href":"//assets.thejuly.com"},{"rel":"preconnect","href":"//cms.thejuly.com"},{"rel":"preconnect","href":"//www.google-analytics.com"},{"rel":"preconnect","href":"//www.googletagmanager.com"},{"rel":"preconnect","href":"//consent.cookiebot.com"}],"style":[{"hid":"css-variables","children":":root { --color-darkest:#000;--color-lightest:#fff;--color-primary:var(--color-lightest);--color-primary-light:rgba(255, 255, 255, 0.6);--color-primary-dark:rgba(255, 255, 255, 0.5);--color-secondary:var(--color-lime);--color-secondary-light:rgba(204, 204, 163, 0.6);--color-secondary-dark:rgba(204, 204, 163, 0.5);--color-highlight-error:#ce2e2e;--color-highlight-warning:#ffffff;--color-highlight-info:#ffffff;--color-highlight-success:#ffffff;--color-cream:#e5e0db;--color-pale-blue:#73808f;--color-pink:#d48080;--color-bright-orange:#de815d;--color-oasis-green:#293b24;--color-lime:#cccca3;--color-tertiary:transparent;--color-tertiary-light:rgba(0, 0, 0, 0.5);--color-tertiary-dark:var(--color-darkest);--transition-timing-slower:3s;--transition-timing-slow:1s;--transition-timing-medium:400ms;--transition-timing-fast:250ms;--transition-timingFunction-in:cubic-bezier(0.8, 0, 0.7, 1);--transition-timingFunction-out:cubic-bezier(.1, 1, 0.2, 1);--transition-timingFunction-in-out:cubic-bezier(0.4, 0, 0.2, 1);--transition-fast:var(--transition-timing-fast) 0ms var(--transition-timingFunction-in);--transition-medium:var(--transition-timing-medium) 0ms var(--transition-timingFunction-in);--transition-slow:var(--transition-timing-slow) 0ms var(--transition-timingFunction-in);--spacing-2xs:.5rem;--spacing-xs:0.75rem;--spacing-sm:1rem;--spacing-md:1.5rem;--spacing-lg:2rem;--spacing-xl:3rem;--spacing-2xl:4rem;--spacing-3xl:4.5rem;--grid-maxWidth-page:1440px;--grid-full-bleed:left-side-gutter / -1;--grid-full-width:first / right-side-gutter;--grid-full-height:1 / -1;--grid-column-width:29%;--grid-gutter-width:6.5%;--grid-gutter-margin:min(6.5vw, 93px);--borderRadius-sm:0;--borderRadius-md:3.125rem;--borderRadius-lg:6.25rem;--borderRadius-xl:6.25rem;--borderRadius-full:9999px;--boxShadow-outline:0px 0px 0px 3px rgba(0, 0, 0, 0.20);--font-family-primary:PP Mori, PP Mori fallback, sans-serif;--font-family-secondary:PP Fragment, PP Fragment fallback, serif;--font-size-xs:0.625rem;--font-size-sm:0.75rem;--font-size-md:0.875rem;--font-size-lg:1rem;--font-size-xl:1.125rem;--font-size-2xl:1.25rem;--font-size-3xl:1.375rem;--font-size-4xl:1.5rem;--font-size-5xl:2rem;--font-size-6xl:2.5rem;--font-weight-primary-normal:400;--font-weight-primary-semibold:600;--font-weight-primary-bold:600;--font-weight-secondary-normal:400;--lineHeight-xs:1;--lineHeight-md:140%; }","type":"text/css"}],"script":[],"noscript":[],"titleTemplate":"%s"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true